import React, { Component } from 'react';
import config from 'react-global-configuration';

import Topo from '../Layout/Topo';
import RequestApi from '../Miscelania/RequestApi';
import CalendarDay from './Elements/CalendarDay';

class Calendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      dados: [],
      atual: '',
      proximo: '',
      anterior: '',
    };
    this.calendario = this.calendario.bind(this);
    this.proximo = this.proximo.bind(this);
    this.anterior = this.anterior.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
    var now = new Date();
    var mes = (now.getMonth()) + 1;
    var ano = now.getFullYear();
    var referencia = mes + '/' + ano;
    this.calendario(referencia);
  }

  calendario(referencia) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/calendario/' + referencia;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            dados: responseJson.data,
            anterior: responseJson.datas.anterior,
            atual: responseJson.datas.atual,
            proximo: responseJson.datas.proximo,
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  proximo() {
    this.calendario(this.state.proximo);
  }

  anterior() {
    this.calendario(this.state.anterior);
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} />
  <div className="container-fluid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.anterior}><i className="fa fa-fw fa-chevron-left"></i> {this.state.anterior}</button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.atual}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.proximo}>{this.state.proximo} <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <table className="table calendario">
        <thead>
          <tr>
            <th>Domingo</th>
            <th>Segunda-feira</th>
            <th>Terça-feira</th>
            <th>Quarta-feira</th>
            <th>Quinta-feira</th>
            <th>Sexta-feira</th>
            <th>Sábado</th>
          </tr>             
        </thead>
        <tbody>
        {this.state.dados.map(function(semana, linha) {
          return (
            <CalendarDay semana={semana} />
          );
        })}

        </tbody>
      </table>

    </div>
  </div>
</div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/Components/Calendar/Calendar.js